import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { usePrefersReducedMotion } from '../../../hooks/use-prefers-reduced-motion';
import { MOTION_DURATION_MS, MOTION_EASING, REDUCED_MOTION_QUERY } from '../../../theme/motion';
import { fadeSlideUp } from '../../../theme/shared-styles';
import { DrawnCheckMark } from '../../drawn-check-mark';

const CHECK_SIZE_PX = 64;
// In 24-unit viewBox space: ~4px once scaled to 64px, close to the filled icon it replaces.
const CHECK_STROKE_WIDTH = 1.5;
const RING_DRAW_DELAY_MS = 100;
const TICK_DRAW_DELAY_MS = RING_DRAW_DELAY_MS + MOTION_DURATION_MS.layout / 2;
// The title lands as the tick finishes: outcome first, words right after.
const TITLE_DELAY_MS = TICK_DRAW_DELAY_MS + MOTION_DURATION_MS.routine / 2;

export function SuccessStep() {
  const { t } = useTranslation();
  const prefersReducedMotion = usePrefersReducedMotion();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        textAlign: 'center',
        py: 2,
      }}
    >
      <DrawnCheckMark
        animate={!prefersReducedMotion}
        size={CHECK_SIZE_PX}
        strokeWidth={CHECK_STROKE_WIDTH}
        circleDelayMs={RING_DRAW_DELAY_MS}
        tickDelayMs={TICK_DRAW_DELAY_MS}
        tickDurationMs={MOTION_DURATION_MS.routine}
      />
      <Typography
        variant="h6"
        role="status"
        sx={{
          animation: prefersReducedMotion
            ? 'none'
            : `${fadeSlideUp} ${MOTION_DURATION_MS.layout}ms ${MOTION_EASING.arrive} ${TITLE_DELAY_MS}ms both`,
          [REDUCED_MOTION_QUERY]: { animation: 'none' },
        }}
      >
        {t('signature.successTitle')}
      </Typography>
    </Box>
  );
}
